export const IS_NOT_EMPTY_LIST = (inputList: any[]): boolean => {
	return inputList != undefined && inputList != null && inputList.length > 0;
};

export const IS_EMPTY_LIST = (inputList: any[]): boolean => {
	return !IS_NOT_EMPTY_LIST(inputList);
};
